import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class FuncionesService {

  constructor() { }

  digitoValido(dv : String) {
    if (dv != '0' && dv != '1' && dv != '2' && dv != '3' && dv != '4' && dv != '5' && dv != '6' && dv != '7' && dv != '8' && dv != '9' && dv != 'k' && dv != 'K') {
        return false;
    }
    return true;
  }

  quitarFormato(rut : String){
    var strRut = new String(rut);
    while (strRut.indexOf(".") != -1) {
        strRut = strRut.replace(".", "");
    }
    while (strRut.indexOf("-") != -1) {
        strRut = strRut.replace("-", "");
    }
    return strRut;
  }

  getDigito(rut) {
    var dvr = '0';
    let suma : number; 
    let mul : number; 
    suma = 0;
    mul = 2;
    let i : number; 
    let res : number; 
    for (i = rut.length - 1; i >= 0; i--) {
        suma = suma + rut.charAt(i) * mul;
        if (mul == 7) {
            mul = 2;
        } else {
            mul++;
        }
    }
    res = suma % 11;
    if (res == 1) {
        return 'k';
    } else if (res == 0) {
        return '0';
    } else {
        return 11 - res;
    }
  }

  digitoCorrecto(crut : String) {
    let largo : number; 
    let rut : String; 
    let dvr : String; 
    let dv : String; 
    largo = crut.length;
    if (largo < 2) {
        return false;
    }
    if (largo > 2) {
        rut = crut.substring(0, largo - 1);
    } else {
        rut = crut.charAt(0);
    }
    dv = crut.charAt(largo - 1);
    this.digitoValido(dv);
    if (rut == null || dv == null) {
        return 0;
    }
    dvr = this.getDigito(rut).toString();
    if (dvr != dv.toLowerCase()) {
        return false;
    }
    return true;
  }

  validarrut (texto : String) {
        texto = this.quitarFormato(texto);
        let largo : number; 
        largo = texto.length;
        let rutFormateado = "";
        // rut muy corto
        if (largo < 2) {
            return false;
        }
        let i : number; 
        // verifica que los numeros correspondan a los de rut
        for (i = 0; i < largo; i++) {
            // numero o letra que no corresponda a los del rut
            if (!this.digitoValido(texto.charAt(i))) {
                return false;
            }
        }
        var invertido = "";
        let j : number; 
        for (i = (largo - 1), j = 0; i >= 0; i--, j++) {
            invertido = invertido + texto.charAt(i);
        }
        var dtexto = "";
        dtexto = dtexto + invertido.charAt(0);
        dtexto = dtexto + '-';
        let cnt : number; 
        cnt = 0;
        for (i = 1, j = 2; i < largo; i++, j++) {
            if (cnt == 3) {
                dtexto = dtexto + '.';
                j++;
                dtexto = dtexto + invertido.charAt(i);
                cnt = 1;
            } else {
                dtexto = dtexto + invertido.charAt(i);
                cnt++;
            }
        }
        invertido = "";
        for (i = (dtexto.length - 1), j = 0; i >= 0; i--, j++) {
            invertido = invertido + dtexto.charAt(i);
        }
        rutFormateado = invertido;
        //alert($scope.rutV);
        //return invertido;
        //console.log(invertido);
        if (this.digitoCorrecto(texto)) {
            return true;
        }
        return false;
    }
    
}